// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import HeaderDataCell from './HeaderDataCell'
import Row from './server/elements/Row'
import { memo } from 'react'
import { useColumns } from './utils/TableStore'

function HeaderRow<T extends Record<string, unknown>>() {
  const columns = useColumns<T>()
  return (
    <Row>
      {columns.map((column, i) => (
        <HeaderDataCell key={column} field={column} firstRow colIndex={i} />
      ))}
    </Row>
  )
}

export default memo(HeaderRow)
